module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "mainStickyHeader"
    }
  }, [_c('div', {
    staticClass: "row header-wrap-inner"
  }, [_c('li', {
    staticClass: "header-left"
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "header-title"
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.is_viewing))])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2"
  }, [_c('component-account-menu')], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.setPanel) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "banner-menu"
  }, [_c('div', {
    staticClass: "menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile', 'profile')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('orders', 'orders')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('sellpoints')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('buypoints', 'buypoints')
      }
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('collections', 'collections')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _vm._m(9)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('sidehustle', 'sidehustle')
      }
    }
  }, [_vm._m(10), _vm._v(" "), _vm._m(11)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings', 'settings')
      }
    }
  }, [_vm._m(12), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('storage', 'storage')
      }
    }
  }, [_vm._m(14), _vm._v(" "), _vm._m(15)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('knowledge', 'knowledge')
      }
    }
  }, [_vm._m(16), _vm._v(" "), _vm._m(17)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('invite', 'invite')
      }
    }
  }, [_vm._m(18), _vm._v(" "), _vm._m(19)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.setPanel) ? _c('div', {
    staticClass: "panel"
  }, [(_vm.menu_view.profile) ? _c('div', [_vm._v("\r\n              hi pro\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.orders) ? _c('div', [_c('component-orders')], 1) : _vm._e(), _vm._v(" "), (_vm.menu_view.collections) ? _c('div', [_c('component-collections')], 1) : _vm._e(), _vm._v(" "), (_vm.menu_view.sellpoints) ? _c('div', [_vm._l((_vm.sellpoints), function(sellpoint, index) {
    return _c('div', {
      staticClass: "card card-01"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusiness', sellpoint)
        }
      }
    }, [_vm._m(20, true), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": sellpoint.business_brand_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(sellpoint.business_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(sellpoint.business_username))])])]), _vm._v(" "), _vm._m(21, true)])])])
  }), _vm._v(" "), (!_vm.sellpoints.length) ? _c('div', [_c('p', [_vm._v("You have not added any Business yet")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusiness', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2) : _vm._e(), _vm._v(" "), (_vm.menu_view.viewBusiness) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "page-top-header sticky-tab",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "col-xs-2 header-left",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "headTagBack"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 card-label"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card card-label"
  }, [_c('div', {
    staticClass: "card-label-left"
  }, [_c('div', {
    staticClass: "card-avatar-circle card-label-avatar-circle"
  }, [(_vm.sellpoint.business_brand_image) ? _c('img', {
    attrs: {
      "src": _vm.sellpoint.business_brand_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-label-right"
  }, [_c('div', {
    staticClass: "card-arm-line"
  }, [_c('p', {
    staticStyle: {
      "padding-top": "9px"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name)), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "float": "right",
      "margin-right": "1.3em"
    }
  }, [_c('div', {
    staticClass: "leftbtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('manageBusiness', _vm.sellpoint, '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide"
  }, [_c('ul', [_c('li', [_vm._v("< "), _c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessProfile"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessProfile', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "viewBusiness"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewBusiness', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessOrders"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessOrders', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessShippingInformation"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Shipping")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessDiscountsCoupons"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessDiscountsCoupons', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Discounts")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessTransactions"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessTransactions', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Transactions")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessPaymentInformation"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessPaymentInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Payments")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessPosts"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessPosts', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Posts")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "manageBusiness"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('manageBusiness', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("More")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-after-stick",
    staticStyle: {
      "padding": "0.7em"
    }
  }, [(!_vm.menu_tab_view.newBusinessPosts) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('manageBusiness')
      }
    }
  }, [_vm._v("settings")]) : _vm._e(), _vm._v(" "), ((_vm.menu_tab_view.viewBusiness) || (Object.keys(_vm.menu_tab_view).length === 0)) ? _c('div', [_c('div', {
    staticClass: "card card-flat",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.sellpoint.business_agent == 0) ? _c('h6', [_vm._v("Business Name")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('h6', [_vm._v("Agent Business Name")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.sellpoint.business_category))])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategory', _vm.sellpoint)
      }
    }
  }, [_vm._v("Add New Category")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v("Product Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(category, index) {
    return _c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusinessCategory', _vm.sellpoint, category)
        }
      }
    }, [_c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('p', [(category.business_parent_category != 'None') ? _c('span', [_c('b', [_vm._v(_vm._s(category.business_parent_category))]), (category.business_category && (category.business_category != '')) ? _c('span', [_vm._v("-" + _vm._s(category.business_category))]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(category.business_category_name))])])])])])
  }), _vm._v(" "), (!_vm.sellpoint.business_categories) ? _c('div', [_c('p', [_vm._v("You have not added any Category yet")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategory', _vm.sellpoint)
      }
    }
  }, [_vm._v("Add New Category")])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setNewBusinessPosts', _vm.sellpoint, '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setNewBusinessPosts) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em",
      "height": "auto"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategory', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Category / Product / Service")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(7, 'Featured Products')
      }
    }
  }, [_vm._v("Featured Products")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(2, 'Post')
      }
    }
  }, [_vm._v("Post")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(5, 'Event')
      }
    }
  }, [_vm._v("Event")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(4, 'News')
      }
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setNewPost(6, 'Deals')
      }
    }
  }, [_vm._v("Deals")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.manageBusiness) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat component-tabs"
  }, [_c('h6', [_vm._v("Business Settings")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessProfile', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(23)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessOrders', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(24)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessTransactions', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(25)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(26)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessShippingLocations', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(27)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessDiscountsCoupons', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(28)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessPaymentInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(29)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCommisssions', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(30)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessRewards', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(31)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessDeleteRequest', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(32)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessProfile) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(33), _vm._v(" "), (!_vm.menu_tab_inner_view.editBusinessProfile) ? _c('div', {
    staticClass: "card"
  }, [_c('p', [_c('b', [_vm._v("Business Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Tagline: ")]), _vm._v(_vm._s(_vm.sellpoint.business_tagline))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Brief: ")]), _vm._v(_vm._s(_vm.sellpoint.business_profile))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Emails: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Business Phone: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBusinessProfile', '', '')
      }
    }
  }, [_vm._v("Edit Business Profile")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Registered Markets")]), _vm._v(" "), (_vm.sellpoint.business_market_groups_registrations && _vm.sellpoint.business_market_groups_registrationslength != 0) ? _c('div', [_vm._l((_vm.sellpoint.business_market_groups_registrations), function(rg, rgdex) {
    return _c('p', [_vm._v(" >> " + _vm._s(rg.business_market_group_registration_name))])
  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Business Profile Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Sellpoint Banner Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Banner Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_banner_image')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("Sellpoint Profile Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.sellpoint.business_brand_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change ProfilePhoto")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeBannerImage($event, 'business_brand_image')
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.editBusinessProfile) ? _c('div', [_c('hr'), _vm._v(" "), _c('h6', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessOrders) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(34), _vm._v(" "), (_vm.sellpoint_orders && (Object.keys(_vm.sellpoint_orders).length === 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No orders yet")]) : _vm._e(), _vm._v(" "), (_vm.viewOrder) ? _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._v("Order number: " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', [_vm._v("Date: " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _c('div', [_vm._v("Payment method: Online Payment")]), _vm._v(" "), _c('div', [_vm._v("Status: "), _c('span', {
    style: ({
      color: _vm.order.order_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Order Amount: ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', [_vm._v("Shipping:  ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', [_vm._v("Total: ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Delivery Location: " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', [_vm._v("Address: " + _vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\r\n                                " + _vm._s(item.order_item_no) + "\r\n                              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                                " + _vm._s(item.product_name) + "\r\n                                "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)])]), _vm._v(" "), (_vm.order.order_payment_status_id != 18) ? _c('div', {
    staticClass: "mobile-fix-nav-2"
  }, [_c('p', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.order.order_status_id == 20) ? _c('div', {
    staticStyle: {
      "background": "#337ab7",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrderPayment(_vm.order)
      }
    }
  }, [_vm._v("Confirm Order")])]) : _vm._e(), _vm._v(" "), (_vm.order.order_status_id == 2) ? _c('div', {
    staticStyle: {
      "background": "#e94b4b",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.updateOrders(_vm.order, 'delivered')
      }
    }
  }, [_vm._v("Mark order as delivered")])]) : _vm._e()]) : _vm._e()]) : _c('div', _vm._l((_vm.sellpoint_orders), function(order, odex) {
    return _c('div', {
      key: _vm.orderComponentKey,
      staticClass: "card card-flat-pad"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('orders', order)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_time_ago))]), _c('br'), _vm._v(_vm._s(order.order_user)), _c('br'), _c('b', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (order.order_status_id == 20) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_c('b', [_vm._v("Confirm order")])]) : _vm._e(), _vm._v(" "), (order.order_status_id == 2) ? _c('p', {
      staticStyle: {
        "color": "#e94b4b"
      }
    }, [_vm._v("Mark order as delivered")]) : _vm._e(), _vm._v(" "), (order.order_status_id == 18) ? _c('p', {
      staticStyle: {
        "color": "#337ab7"
      }
    }, [_vm._v("Delivered")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(order.order_items && (order.order_items.length != 0)) ? _c('span', [_c('b', [_vm._v(_vm._s(order.order_items.length) + " item(s)")]), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((order.order_items), function(item, idex) {
      return (idex < 2) ? _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "35",
          "width": "35"
        }
      })]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessTransactions) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('div', [_vm._m(36), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "30%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_transactions.transactions_total_today))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Transactions")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "45%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("NGN" + _vm._s(_vm.sellpoint_transactions.transactions_total_today_amount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Amount Received")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', [_vm._m(37), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "30%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_transactions.transactions_total))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Transactions")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "45%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("NGN" + _vm._s(_vm.sellpoint_transactions.transactions_total_amount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Total Amount Received")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v(_vm._s(_vm.sellpoint_transactions.transactions_total) + " Transactions")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.sellpoint_transactions.transactions), function(tx, tdex) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "left",
        "width": "55%"
      }
    }, [_c('b', [_vm._v(_vm._s(tx.transaction_user_name))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "35%"
      }
    }, [_vm._v("  ₦" + _vm._s(tx.transaction_amount_paid))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['TX' + tdex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(38, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('TX' + tdex)
        }
      }
    }, [_vm._m(39, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['TX' + tdex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bolder",
        "font-size": "18px"
      }
    }, [_vm._v(" . . .")]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(40, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_user_name))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(41, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_details))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(42, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v("₦" + _vm._s(tx.transaction_amount_paid))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(43, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_type_name))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(44, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_payment_ref))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "card card-strip"
    }, [_vm._m(45, true), _vm._v(" "), _c('div', {
      staticClass: "card-right-50"
    }, [_c('p', [_vm._v(_vm._s(tx.transaction_payment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])]) : _vm._e()])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessShippingInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(46), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(47), _vm._v(" "), (_vm.business_details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('div', [_c('p', {
    staticClass: "sp-info-text-box"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" edit")])]) : _c('p', [_vm._v("You have not set any delivery information\r\n                          "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus(9)
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus(10)
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus(11)
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessShippingLocations) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), (_vm.sellpoint.business_delivery_options && (_vm.sellpoint.business_delivery_options.length == 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("\r\n                      You have not set any delivery location.\r\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('h5', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Editing " + _vm._s(delivery_option.business_delivery_option))]), _vm._v(" "), (delivery_option.business_delivery_is_custom && (delivery_option.business_delivery_is_custom == 1)) ? _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Location")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_custom_option),
        expression: "delivery_option.business_delivery_custom_option"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (delivery_option.business_delivery_custom_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_custom_option = $event.target.value
        }
      }
    })])]) : _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_state))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state_id),
        expression: "delivery_option.business_delivery_state_id"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state_id, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                              " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                              "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.business_details.delivery_add) ? _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")]) : _vm._e(), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_delivery_option),
      expression: "custom_delivery_option"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.custom_delivery_option) ? _vm._i(_vm.custom_delivery_option, null) > -1 : (_vm.custom_delivery_option)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.custom_delivery_option,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.custom_delivery_option = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.custom_delivery_option = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.custom_delivery_option = $$c
        }
      }
    }
  }), _vm._v(" Do you want to add customised delivery locations(Suitable for Countries outside Nigeria)\r\n                        "), (_vm.custom_delivery_option) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Location")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_custom_option),
      expression: "delivery_option.delivery_custom_option"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "eg. Country, City, Location"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_custom_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_custom_option = $event.target.value
      }
    }
  })])]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessDiscountsCoupons) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                            You can set individual Product Discounts on thier product pages.\r\n                        ")]), _vm._v(" "), (_vm.sellpoint.business_discounts_coupons && (_vm.sellpoint.business_discounts_coupons.length == 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("\r\n                          You have not set any dicount or coupon.\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(48)]) : _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date1: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [(_vm.sellpoint.business_discounts_coupons && (_vm.sellpoint.business_discounts_coupons.length != 0)) ? _c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Minimum Quantity: ")]), _vm._v(_vm._s(dc.discount_min_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                      Edit Coupon")]), _vm._v("    \r\n                                  "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                      Deactivate Coupon")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])
  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessPaymentInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(49), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(50), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set up your Bank Details for direct Transfers")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setBankDetails')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setBankDetails || _vm.menu_tab_inner_view.editBankDetails) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Bank Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), _c('div', [(_vm.sellpoint.business_bank_details.length == 0 || _vm.menu_tab_inner_view.editBankDetails) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_name),
      expression: "sellpoint.business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_number),
      expression: "sellpoint.business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("your details are secured")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]), _vm._v(" "), _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ravepay_sba.account_bank),
      expression: "ravepay_sba.account_bank"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ravepay_sba.account_bank = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Code
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ravepay_sba.account_number),
      expression: "ravepay_sba.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.ravepay_sba.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ravepay_sba.account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.sellpoint.business_contact_email || (_vm.sellpoint.business_contact_email == '')) ? _c('label', [_c('b', [_vm._v("Contact Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_contact_email),
      expression: "sellpoint.business_contact_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_contact_email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.sellpoint.business_contact_phone || (_vm.sellpoint.business_contact_phone == '')) ? _c('label', [_c('b', [_vm._v("Contact Phone Number:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_contact_phone),
      expression: "sellpoint.business_contact_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_contact_phone = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.setBankDetailsRavePay
    }
  }, [_vm._v("Save Bank Details")])])]) : _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBankDetails', '')
      }
    }
  }, [_vm._v("Edit Bank Details")])]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(51), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set how you would want to settle your proccessing fees")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setProcessingFees')
      }
    }
  }, [_vm._v("Set")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setProcessingFees || _vm.menu_tab_inner_view.addProcessingFees) ? _c('div', [_c('div', [_c('h6', [_vm._v("Processing Fee Balance")]), _vm._v(" "), _vm._m(52), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance) ? _c('p', [_vm._v("Processing Fee Balance: "), _c('b', [(_vm.sellpoint.business_processing_fee_balance < 1000) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))]) : _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))])])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_processing_fee_balance < 2000) && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                            Processing Fee is running low\r\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                            Processing Fee is low\r\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_debt > 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                            Processing Fee is low and you are owing processing fee charge of "), _c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(" -" + _vm._s(_vm.sellpoint.business_processing_fee_debt))])]) : _vm._e(), _vm._v(" "), (!_vm.menu_tab_inner_view.addProcessingFees) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addProcessingFees')
      }
    }
  }, [_vm._v("Add Processing Fees")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.addProcessingFees) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h6', [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                          be paid by you as you set your product, or by your customers as they buy. \r\n                          Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(54), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(55), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Ravepay  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Ravepay Website to create and set up your account")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setRavepay')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setRavepay) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Ravepay Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_ravepay_accounts && (_vm.sellpoint.business_ravepay_accounts.length > 0)) ? _c('div', [_c('p', [_vm._v("Accounts on Ravepay")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_ravepay_accounts), function(pg) {
    return _c('div', {
      staticClass: "card"
    }, [_vm._v("\r\n                              " + _vm._s(pg.account_email) + "\r\n                            ")])
  })], 2) : _c('p', {
    staticClass: "info-processing"
  }, [_vm._v("No Ravepay Account set yet")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60)])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCommisssions) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(61), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad"
  }, [_vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _c('p', [_c('b', [_vm._v("Agent Commision:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_agent_commission) + "%")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setAgentCommission')
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setAgentCommission || _vm.menu_tab_inner_view.editAgentCommission) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Agents Commission")]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_c('b', [_vm._v("Commissiom:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_agent_commission),
      expression: "sellpoint.business_agent_commission"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "5"
    },
    domProps: {
      "value": (_vm.sellpoint.business_agent_commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_agent_commission = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setBusinessAgentCommissions()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(64), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set how you would want to settle your proccessing fees")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setProcessingFees')
      }
    }
  }, [_vm._v("Set")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.menu_tab_inner_view.setProcessingFees || _vm.menu_tab_inner_view.addProcessingFees) ? _c('div', [_c('div', [_c('h6', [_vm._v("Processing Fee Balance")]), _vm._v(" "), _vm._m(65), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance) ? _c('p', [_vm._v("Processing Fee Balance: "), _c('b', [(_vm.sellpoint.business_processing_fee_balance < 1000) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))]) : _c('span', [_vm._v(_vm._s(_vm.sellpoint.business_processing_fee_balance))])])]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_processing_fee_balance < 2000) && (_vm.sellpoint.business_processing_fee_balance > 0)) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                            Processing Fee is running low\r\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_balance == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                            Processing Fee is low\r\n                          ")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_debt > 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("\r\n                            Processing Fee is low and you are owing processing fee charge of "), _c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(" -" + _vm._s(_vm.sellpoint.business_processing_fee_debt))])]) : _vm._e(), _vm._v(" "), (!_vm.menu_tab_inner_view.addProcessingFees) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addProcessingFees')
      }
    }
  }, [_vm._v("Add Processing Fees")]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.addProcessingFees) ? _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processing_fee.amount),
      expression: "processing_fee.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.processing_fee.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.processing_fee.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.addtoProcessingFee()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h6', [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                          be paid by you as you set your product, or by your customers as they buy. \r\n                          Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(66), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(67), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessRewards) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(68), _vm._v(" "), _vm._l((_vm.sellpoint.reward_settings), function(reward_type) {
    return _c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('p', [_c('b', [_vm._v(_vm._s(reward_type.reward_type_name))])]), _vm._v(" "), _c('p', {
      staticClass: "p-tiny-info"
    }, [_vm._v(_vm._s(reward_type.reward_type_descr))]), _vm._v(" "), (reward_type.reward_type_is_set) ? _c('div', [_c('a', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('edit' + reward_type.reward_type_name + reward_type.reward_type_id)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward: \r\n                          "), (reward_type.reward_type_setting.reward_set_amount_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), (reward_type.reward_type_setting.reward_set_amount) ? _c('span', [_vm._v(_vm._s(reward_type.reward_type_setting.reward_set_amount))]) : _vm._e(), _vm._v(" "), (reward_type.reward_type_setting.reward_set_amount_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()])])]) : _c('div', [_c('a', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('set' + reward_type.reward_type_name + reward_type.reward_type_id)
        }
      }
    }, [_vm._v("SET")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "13px"
      }
    }, [_vm._v("No reward set")])]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id] || _vm.menu_tab_inner_view['edit' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('div', [_c('h6', {
      staticClass: "margin-t-40"
    }, [_vm._v("Set a Reward for " + _vm._s(reward_type.reward_type_name) + " ")]), _vm._v(" "), _c('form', {
      staticClass: "sp-form",
      staticStyle: {
        "padding-left": "0"
      }
    }, [_c('label', [_c('b', [_vm._v("Reward Amount: "), (reward_type.reward_type_setting.reward_set_amount) ? _c('span', [_vm._v(_vm._s(reward_type.reward_type_setting.reward_set_amount))]) : _vm._e()]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.business_details.set_reward_type_amount),
        expression: "business_details.set_reward_type_amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "25%",
        "margin-right": "5px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.business_details.set_reward_type_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.business_details.set_reward_type_amount = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_reward_type_amount_type),
        expression: "set_reward_type_amount_type"
      }],
      staticClass: "sp-form-select form-control",
      staticStyle: {
        "width": "45%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.set_reward_type_amount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("% (percentage)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("₦ (cash)")])])]) : _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward_type.reward_type_setting.reward_set_amount),
        expression: "reward_type.reward_type_setting.reward_set_amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "25%",
        "margin-right": "5px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (reward_type.reward_type_setting.reward_set_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          reward_type.reward_type_setting.reward_set_amount = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward_type.reward_type_setting.reward_set_amount_type),
        expression: "reward_type.reward_type_setting.reward_set_amount_type"
      }],
      staticClass: "sp-form-select form-control",
      staticStyle: {
        "width": "45%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          reward_type.reward_type_setting.reward_set_amount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("% (percentage)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("₦ (cash)")])])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.postBusinessRewardSettings(reward_type)
        }
      }
    }, [_vm._v("Save")]) : _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.updateBusinessRewardSettings(reward_type.reward_type_setting)
        }
      }
    }, [_vm._v("Save")])]), _vm._v(" "), _c('a', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessDeleteRequest) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._v("\r\n                    Request all Business Information to be deleted\r\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessPosts) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(69), _vm._v(" "), (_vm.posts && (Object.keys(_vm.posts).length === 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No post yet")]) : _vm._e(), _vm._v(" "), (_vm.viewPost) ? _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "text-align:left"
  }, [(_vm.post.post_media.length > 0) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.post.post_media[0].post_media,
      "height": "35",
      "width": "35"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.post.post_title))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.post.post_time_ago))]), _c('br'), _vm._v(_vm._s(_vm.post.post_post))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('div', {}, _vm._l((_vm.post.post_media), function(post_media) {
    return (_vm.post.post_media && (_vm.post.post_media.length > 0)) ? _c('div', [_c('img', {
      attrs: {
        "src": post_media.post_media,
        "height": "35",
        "width": "35"
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {}, _vm._l((_vm.post.post_products), function(product, index) {
    return (_vm.post.post_products && (_vm.post.post_products.length > 0)) ? _c('div', [_c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusinessCategoryProduct', _vm.sellpoint, product)
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f) + " - ₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(!_vm.menu_tab_inner_view.addBusinessPostNotification) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addBusinessPostNotification')
      }
    }
  }, [_vm._v("Add a Notification")]) : _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), (_vm.menu_tab_inner_view.addBusinessPostNotification) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add notification to " + _vm._s(_vm.post.post_title))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_notification),
      expression: "post.post_notification"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.post.post_notification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_notification = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addNewPostNotification
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()])]) : _c('div', _vm._l((_vm.posts), function(post, psdex) {
    return _c('div', {
      staticClass: "card card-strip"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('posts', post)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('p', [_vm._v("\r\n                              " + _vm._s(post.post_title)), _c('br'), _c('b', [_vm._v(_vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "sp-app-default-text-color-dim-1",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(post.post_type_name)), _c('br')]), _vm._v(" "), (post.post_media && (post.post_media.length > 0)) ? _c('div', [_c('img', {
      attrs: {
        "src": post.post_media[0].post_media,
        "height": "35",
        "width": "35"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.menu_view.viewBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "page-top-header sticky-tab",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "col-xs-2 header-left",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "headTagBack"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 card-label"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card card-label"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "0.5em"
    }
  }, [_c('div', {
    staticClass: "card-arm-line"
  }, [_c('p', {
    staticStyle: {
      "padding-top": "9px"
    }
  }, [_c('b', [_vm._v("Category: ")]), _vm._v(_vm._s(_vm.category.business_category) + "\r\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "display": "none",
      "padding": "0",
      "margin": "0",
      "float": "right",
      "margin-right": "1.3em"
    }
  }, [_c('div', {
    staticClass: "leftbtn",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide"
  }, [_c('ul', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "viewBusinessCategory"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "manageBusinessCategory"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('manageBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Settings")])])])])]), _vm._v(" "), _c('div', {
    key: _vm.businessComponentKey,
    staticClass: "row-after-stick"
  }, [((_vm.menu_tab_inner_view.viewBusinessCategory) || (Object.keys(_vm.menu_tab_inner_view).length === 0)) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "0 1em",
      "height": "auto"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(71)]) : _c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [(_vm.category.category_products) ? _c('span', [_vm._v("Total Products:" + _vm._s(_vm.category.category_products.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sellpoint.business_agent == 0) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessAgentCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Business and Products")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('p', [_vm._v("products in " + _vm._s(_vm.category.business_category_name))]), _vm._v(" "), (_vm.category.category_products && (_vm.category.category_products.length != 0)) ? _c('div', _vm._l((_vm.category.category_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setBusinessComponent('viewBusinessCategoryProduct', _vm.sellpoint, product)
        }
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f) + " - ₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-arm-alt-bottom"
    }, [_c('div', {
      staticClass: "card-analytics"
    }, [_c('ul', [_c('li', {
      staticClass: "card-tag-qty"
    }, [_c('i', {
      staticClass: "fa fa-tag"
    }), _c('span', [_vm._v(_vm._s(product.product_total_quantity))])]), _vm._v(" "), _c('li', {
      staticClass: "card-tag-orders"
    }, [_c('i', {
      staticClass: "fa fa-shopping-cart"
    }), _c('span', [_vm._v(_vm._s(product.product_total_orders))])])])])])])])])
  })) : _c('div', [_c('p', [_vm._v("No products in this category")])]), _vm._v(" "), (_vm.sellpoint.business_agent == 0) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessAgentCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Add New Business and Products")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.manageBusinessCategory) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_c('h6', [_vm._v("Category Settings")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('p', [_c('b', [_vm._v("Category Name: ")]), _vm._v(_vm._s(_vm.category.business_category_name))]), _vm._v(" "), (_vm.category.can_edit == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You can not edit this category name, it has a default setting")]) : _vm._e(), _vm._v(" "), (_vm.category.can_edit == 1) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('editBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Rename "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.category.business_category))])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('p', [_vm._v("Category Image")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.category.business_category_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "12px",
      "line-height": "0.6"
    },
    attrs: {
      "disabled": _vm.disable_btn
    }
  }, [_vm._v("Change Category Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_category', _vm.category.business_category_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deleteBusinessCategory', _vm.sellpoint, _vm.category)
      }
    }
  }, [_vm._v("Delete Category")])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.editBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('h6', [_vm._v("Rename " + _vm._s(_vm.category.business_category))]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel "), _c('i', {
    staticClass: "fa fa-ban"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.deleteBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('p', [_vm._v("Do you want to Delete this Category and all products within it")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "info info-processing"
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteCategory
    }
  }, [_vm._v("Yes,Request Delete")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottombtn"
  }, [(_vm.sellpoint.business_agent == 0) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_agent == 1) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('newBusinessAgentCategoryProduct', _vm.sellpoint, _vm.category)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusiness) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_agent),
      expression: "business_agent"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.business_agent, "0")
    },
    on: {
      "__c": function($event) {
        _vm.business_agent = "0"
      }
    }
  }), _vm._v(" Personal Business")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_agent),
      expression: "business_agent"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.business_agent, "1")
    },
    on: {
      "__c": function($event) {
        _vm.business_agent = "1"
      }
    }
  }), _vm._v(" Agent/Side Hustle Business")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Market Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Do you sell in any of these markets?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_market_group),
      expression: "business.business_market_group"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_market_group = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Market")]), _vm._v(" "), _vm._l((_vm.market_groups), function(business_market_group) {
    return _c('option', {
      domProps: {
        "value": business_market_group.business_market_group
      }
    }, [_vm._v(_vm._s(business_market_group.business_market_group_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewBusiness
    }
  }, [_vm._v("Create")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessCategory) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New Category")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select From")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct
      }
    }, [_vm._v(_vm._s(ct.category_name))])
  })], 2)]), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Category under " + _vm._s(_vm.main_category.category_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(72), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category Name"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "change": _vm.resetCategoriesSelections,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('h4', [_c('u', [_vm._v(_vm._s(_vm.category.business_category))])]), _vm._v(" "), _c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("is this a Product or Service?")]), _vm._v(" "), _c('label', {
    staticClass: "line-wrap"
  }, [_vm._v("Product")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  }), _vm._v("\r\n                         \r\n                    "), _c('label', [_vm._v(" Service ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(73), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Provide details of your product/service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    key: _vm.prdItemPriceKey,
    staticClass: "form-group"
  }, [_vm._m(74), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantity ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(75)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessAgentCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('button', {
    staticClass: "pull-right btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Add Business")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_c('u', [_vm._v("Select Products in  " + _vm._s(_vm.category.business_category))])]), _vm._v(" "), _c('div', [(_vm.category.category_business_open_for_agent_products && (_vm.category.category_business_open_for_agent_products.length != 0)) ? _c('div', _vm._l((_vm.category.category_business_open_for_agent_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(76, true)])])])
  })) : _c('div', [_c('p', [_vm._v("No products here yet")])])]), _vm._v(" "), _c('h4', [_vm._v("Other Products that would interest you")]), _vm._v(" "), _c('div', [(_vm.business_open_agents_products) ? _c('div', _vm._l((_vm.business_open_agents_products), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('a', {
      staticClass: "pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewAgentProduct(product, 'addToCreatedAgentBusinessCategory')
        }
      }
    }, [_vm._v("Add to " + _vm._s(_vm.category.business_category))]), _vm._v(" "), _c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewAgentProduct(product, 'addToCreatedAgentBusinessCategory')
        }
      }
    }, [_vm._v("Add to " + _vm._s(product.product_category_name))])]), _vm._v(" "), _vm._m(77, true)])])
  })) : _c('div', [_c('p', [_vm._v("No products here yet")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newBusinessPosts) ? _c('div', [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add " + _vm._s(_vm.post.post_type_name))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption / Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_title),
      expression: "post.post_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Pictures / Videos")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "input-file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeMultiplePrep($event)
      }
    }
  }), _vm._v(" "), (_vm.files_info.length > 0) ? _c('div', _vm._l((_vm.files_info), function(file_info) {
    return _c('p', [_c('span', [_c('b', [_vm._v("Added " + _vm._s(file_info.name))])])])
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    key: _vm.attachProductsComponentKey,
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.post.selected_post_products && (_vm.post.selected_post_products.length > 0)) ? _c('div', _vm._l((_vm.post.selected_post_products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.attachProductToPost(product)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": product.is_attached_to_post == _vm.post.post_temp_id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "50px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.menu_tab_inner_view.viewProducts) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewCategories')
      }
    }
  }, [_vm._v("Back to Categories")]) : (_vm.menu_tab_inner_view.viewCategories) ? _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Close")]) : _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewCategories')
      }
    }
  }, [_vm._v("Attach "), _c('b', [_vm._v("Products / Services")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.menu_tab_inner_view.viewProducts) ? _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Select products from "), _c('b', [_vm._v(_vm._s(_vm.category.business_category_name))])]), _vm._v(" "), _vm._l((_vm.category.category_products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.attachProductToPost(product)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": product.is_attached_to_post == _vm.post.post_temp_id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "50px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(category, index) {
    return (_vm.menu_tab_inner_view.viewCategories) ? _c('div', {
      staticClass: "card"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setAttachProductToPost(category)
        }
      }
    }, [_c('div', {
      staticClass: "card card-flat-pad"
    }, [_c('p', [(category.business_parent_category != 'None') ? _c('span', [_c('b', [_vm._v(_vm._s(category.business_parent_category))]), (category.business_category && (category.business_category != '')) ? _c('span', [_vm._v("-" + _vm._s(category.business_category))]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(category.business_category_name))])])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), (_vm.menu_tab_inner_view.viewProducts) ? _c('div', {
    key: _vm.attachProductsComponentKey,
    staticClass: "form-group",
    staticStyle: {
      "display": "none"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.attachProductToPost(product)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": product.is_attached_to_post == _vm.post.post_temp_id
      }
    }), _vm._v("nn" + _vm._s(product.is_attached_to_post) + "\r\n                      "), _c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "50px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addNewPost
    }
  }, [_vm._v("Add")])])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.viewBusinessCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "page-top-header sticky-tab",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [_c('div', {
    staticClass: "head-tags"
  }, [_c('div', {
    staticClass: "col-xs-2 header-left",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "headTagBack"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 card-label"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    staticClass: "card card-label"
  }, [_c('div', {
    staticClass: "card-label-left"
  }, [_c('div', {
    staticClass: "card-avatar-square card-label-avatar"
  }, [(_vm.product.product_images && (_vm.product.product_images.length != 0)) ? _c('img', {
    attrs: {
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-label-right"
  }, [_c('div', {
    staticClass: "card-arm-line"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_name)), _c('br'), _vm._v(" "), (_vm.product.product_items && (_vm.product.product_items.length != 0)) ? _c('span', [_vm._v("₦" + _vm._s(_vm.product.product_items[0].product_item_price_f))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "float": "right",
      "margin-right": "1.3em"
    }
  }, [_c('div', {
    staticClass: "leftbtn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('manageBusinessCategoryProduct', _vm.sellpoint, _vm.product)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-slide"
  }, [_c('ul', [_c('li', [_vm._v("< "), _c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "viewBusinessCategoryProduct"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewBusinessCategoryProduct', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessCategoryProductDetails"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductDetails', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessCategoryProductItems"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductItems', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Types")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessCategoryProductReviews"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductReviews', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Reviews")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessCategoryProductOrders"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductOrders', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessCategoryProductShippingInformation"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Shipping")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "setBusinessCategoryProductDiscountCoupons"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductDiscountCoupons', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Discounts")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-after-stick"
  }, [(_vm.menu_tab_view.viewBusinessCategoryProduct) ? _c('div', [_c('div', {
    staticClass: "card card-pad"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('h4', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('p', [_vm._v("Quantity: " + _vm._s(_vm.product_item.product_item_quantity) + "  "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemQuantityRestock')
      }
    }
  }, [_vm._v("Restock")])]), _vm._v(" "), (_vm.product_details.setProductItemQuantityRestock) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_quantity_restock),
      expression: "product_item.product_item_quantity_restock"
    }],
    staticClass: "qty-input qty-input-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_quantity_restock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_quantity_restock = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.restockProductItem
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-xs"
  }) : _c('span', [_vm._v("Add")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "320px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "75%"
    }
  }, [(_vm.product_display_image && (_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error')) ? _c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px",
      "width": "100%",
      "height": "25%"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('li', {
      staticClass: "img-column",
      staticStyle: {
        "border": "none"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.product_display_image = pt
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h4', [_vm._v("Product Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h4', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v("Product Groups/Types ")]), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', {}, _vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-container"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "z-index": "3"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                              ")]), _vm._v(" "), _vm._l((pg.product_items), function(pt, ptdex) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap",
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap",
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])])
    })], 2)])])])
  })) : _c('div', [_c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("No Groups/Types set")])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductItems', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("Set Product Groups/Types")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [_c('h4', [_vm._v("Activity Summary")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Quantity: ")]), _vm._v(_vm._s(_vm.product.product_total_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Orders: ")]), _vm._v(_vm._s(_vm.product.product_total_orders))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Reviews: ")]), _vm._v(_vm._s(_vm.product.product_total_reviews))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Rating: ")]), _vm._v(_vm._s(_vm.product.product_total_rating) + " out of 5 (" + _vm._s(_vm.product.product_total_rates) + " rate(s))")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total Views: ")]), _vm._v(_vm._s(_vm.product.product_total_views))])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.manageBusinessCategoryProduct) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "1em",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "card card-flat component-tabs"
  }, [_c('h6', [_vm._v("Product Settings")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductDetails', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(78)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductItems', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(79)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductDiscountCoupons', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(80)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductDeliveryAndReturanInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(81)]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._m(82)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductDetails) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(83), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Name:")]), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Category:")]), _vm._v(" " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), (_vm.product.product_set_items == 0 || (_vm.product.product_items.length == 1)) ? _c('div', [(_vm.product.product_items[0].product_item_actual_price != 0) ? _c('div', [_c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Price:")]), _vm._v(" ₦" + _vm._s(_vm.product.product_items[0].product_item_actual_price_f))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Discounted Price:")]), _vm._v(" ₦" + _vm._s(_vm.product.product_items[0].product_item_price_f))])]) : _c('div', [_c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Price:")]), _vm._v(" ₦" + _vm._s(_vm.product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Weight:")]), _vm._v(" " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "plain-bold"
  }, [_vm._v("Quantity:")]), _vm._v(" " + _vm._s(_vm.product.product_items[0].product_item_quantity))]), _vm._v(" "), (_vm.product_details.setProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    key: _vm.prdItemPriceKey,
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\r\n                            Price\r\n                            "), (_vm.product.product_items[0].product_item_actual_price != 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_actual_price),
      expression: "product.product_items[0].product_item_actual_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_actual_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip01()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_actual_price = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip01()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('label', [_vm._v(" Weight\r\n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', [_vm._v(" Quantity\r\n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm sp-button-style-1",
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "plain-bold"
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), (_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm sp-button-style-1",
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Product Images")]), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length == 0)) ? _c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No image added yet")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px",
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('li', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm sp-button-style-1",
      staticStyle: {
        "font-size": "12px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductItems) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(84), _vm._v(" "), _c('div', [(_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_set_items > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', [_c('p', [_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('show-settings-box', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Settings ")])]), _vm._v(" "), (_vm.show_product_setting_box) ? _c('div', {
    staticClass: "sp-info-text-box"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("General Product Group and Group Items Name")]), _vm._v(" "), _c('p', [_vm._v("This is a general name of this Product's Grouping, you may change it whenever you want")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Group Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Group Items Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change this Name")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "0.8",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('hide-settings-box', '', '')
      }
    }
  }, [_vm._v(" Hide")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.product.product_set_groups == 0) ? _c('div') : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em 0",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-md",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_vm._v("Add new Variation")]), _vm._v(" "), _c('h5', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("Product Groups/Types ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', {}, _vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-container"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "z-index": "3"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('button', {
      staticClass: "btn v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "z-index": "9"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('pgset' + pgdex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'pgset' + pgdex
      }
    }, [_c('button', {
      staticClass: "btn v-tiny-btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                                  ")]), _vm._v(" "), _vm._l((pg.product_items), function(pt, ptdex) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap",
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap",
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), _c('li', {
        staticStyle: {
          "float": "left"
        }
      }, [_c('button', {
        staticClass: "product-item-more-details-view-btn btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        staticStyle: {
          "line-height": "0.8"
        },
        attrs: {
          "id": 'viewbtn' + pgdex + ptdex
        },
        on: {
          "click": function($event) {
            _vm.toggleProductItemView('showMoreProductItemDetails', 'showMoreProductItemDetails' + pgdex + ptdex, 'viewbtn' + pgdex + ptdex, 'hidebtn' + pgdex + ptdex)
          }
        }
      }, [_vm._v(" View Details")])]), _vm._v(" "), _c('li', {
        staticStyle: {
          "float": "left"
        }
      }, [_c('button', {
        staticClass: "product-item-more-details-hide-btn btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        staticStyle: {
          "display": "none",
          "line-height": "0.8"
        },
        attrs: {
          "id": 'hidebtn' + pgdex + ptdex
        },
        on: {
          "click": function($event) {
            _vm.toggleProductItemView('hideMoreProductItemDetails', 'showMoreProductItemDetails' + pgdex + ptdex, 'viewbtn' + pgdex + ptdex, 'hidebtn' + pgdex + ptdex)
          }
        }
      }, [_vm._v(" Hide Details")])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }), _vm._v(" "), _c('div', {
        staticClass: "product-item-show-more-details",
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": 'showMoreProductItemDetails' + pgdex + ptdex
        }
      }, [(_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em",
          "margin-bottom": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', {
        attrs: {
          "align": "left"
        }
      }, [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', {
        staticClass: "sp-form"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [(_vm.product.product_service == 'P') ? _c('span', [_vm._v(" Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v(" Type")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Service Tag\r\n                                          "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Price\r\n                                                "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Weight\r\n                                              "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Quantity\r\n                                              "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-12 col-xs-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-1 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-1 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-1 sp-button-sm",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-1 sp-button-sm",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right",
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      staticStyle: {
        "float": "right",
        "line-height": "1.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")]), _vm._v(" "), _c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v("Name\r\n                                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-2"
    }, [_c('div', {
      staticClass: "box-cube"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-xs-10"
    }, [_c('label', [_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v("Or Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      staticStyle: {
        "line-height": "1.2"
      }
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])]), _c('hr')]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row col-xs-12"
    }, [_c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-1 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-xs-12"
    }, [(_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('label', [_vm._v(" Service Tag\r\n                                      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Price\r\n                                      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Weight(KG)\r\n                                      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Quantity\r\n                                      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      staticStyle: {
        "background": "#e7e8e9"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])])
  })) : _c('div', {
    staticStyle: {
      "margin": "5px 0.89em"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("You have not set any Product item variation")])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.addProductItemPanel) ? _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('h6', [_vm._v("Add New Variation "), (_vm.product.product_groups_set_name) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(Set New " + _vm._s(_vm.product.product_groups_set_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.productVariationComponentKey,
    staticClass: "sp-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\r\n                                      Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\r\n                                          Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [_c('br'), _vm._v(" "), _vm._m(85), _vm._v(" "), ((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#000000",
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name) + " ")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + " (eg:Blue,Black,Custom,Anyname..)\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "change": function($event) {
        (_vm.productVariationComponentKey++)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\r\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "border": "1px dashed #eeccee",
      "padding": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Images/Videos ")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "sp-app-default-text-color-dim-1",
    staticStyle: {
      "color": "#898989"
    }
  }, [_vm._v("Add details of an Item in Group"), (_vm.product.product_item_group_name && (_vm.product.product_item_group_name != '')) ? _c('span', [_vm._v("\r\n                                : ("), _c('b', [_vm._v(_vm._s(_vm.product.product_item_group_name))]), _vm._v(")")]) : _vm._e()])]), _vm._v(" "), _vm._m(86), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_vm._v(" \r\n                                " + _vm._s(_vm.product.product_groups_items_set_name)), _c('br'), _vm._v("(eg:sizes,lengths,materials)\r\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\r\n                                  (eg:big,long,short,xl,m...)"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-4 col-xs-3"
  }, [_c('label', [_vm._v(" Service Tag "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', [_vm._v(" Price\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductDiscountCoupons) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(87), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(88)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Minimum Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_min_quantity),
      expression: "discount_coupon.discount_min_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_min_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_min_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Discounts and Coupons")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Items Discounts and Coupons")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewCoupons) ? _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "border": "#e9e6e6 dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Item Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "items-list-tiny",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.product_item.product_item_group_is_color_image == 'IMG') ? _c('li', [((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image != 'error'))) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.product_item.product_item_group_image
    }
  }) : _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
    staticClass: "btn box-color-cube",
    style: ({
      background: _vm.product_item.product_item_group_color
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (_vm.product_item.product_item_size)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(_vm.product_item.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(_vm.product_item.product_item_quantity))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_type == 5) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Minimum Quantity: ")]), _vm._v(_vm._s(dc.discount_min_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product_item, dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.product_item.product_item_only_coupon_discount_count == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemDiscount', 'productitem', _vm.product_item)
      }
    }
  }, [_vm._v("Set New Item Discount Or Coupon")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "border": "#0d022b dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      staticStyle: {
        "border": "dashed #d1ddf1",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_vm._v("Set New Item Discount Or Coupon")])]), _vm._v(" "), _vm._l((productItem.product_item_discounts), function(dc) {
      return _c('div', [_c('div', [((dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4)) ? _c('p', [_c('b', [_vm._v("General Product Discount")])]) : _vm._e(), _vm._v(" "), (!(dc.discount_type == 4) && !(dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\r\n                                      Edit Discount")]), _vm._v("    \r\n                                    "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', productItem, dc)
          }
        }
      }, [_vm._v("\r\n                                      Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])])
    }), _vm._v(" "), _c('div', [(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("No set discount or coupon")]) : _vm._e()])], 2) : _c('button', {
      staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('viewCoupons', 'productitem', productItem)
        }
      }
    }, [_vm._v("View Coupons and Discounts")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.product.product_items[0]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Product Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn sp-button-1 sp-button-sm pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc) {
    return _c('div', [((dc.discount_type == 4)) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Minimum Quantity: ")]), _vm._v(_vm._s(dc.discount_min_quantity))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                      Edit Discount")]), _vm._v("    \r\n                                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\r\n                                      Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_only_coupon_discount_count == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e()]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductDeliveryAndReturanInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_c('div', [_vm._m(89), _vm._v(" "), (_vm.product_details.edit_product_delivery) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2",
      "font-size": "13px"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                        "), (_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "type": "btn sp-button-1",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('edit_product_delivery', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {}, [_c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.setMenuTabView('setBusinessCategoryProductShippingInformation', _vm.sellpoint, '')
      }
    }
  }, [_vm._v("\r\n                      View Shipping / Delivery Locations\r\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductShippingInformation) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(90), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('div', {
      staticStyle: {
        "margin": "8px 0"
      }
    }, [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\r\n                              ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(" Set Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-1 sp-button-sm",
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', {
    staticClass: "info"
  }, [_vm._v("You have not set your Business Delivery Locations")])])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductOrders) ? _c('div', {
    key: _vm.productOrdersComponentKey
  }, [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(91), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.product.product_orders), function(order) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d",
        "font-size": "10px"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_time_ago))])])]), _c('br'), _vm._v("\r\n                            " + _vm._s(order.order_date) + "\r\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                          " + _vm._s(order.order_user) + "\r\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(order.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_view.setBusinessCategoryProductReviews) ? _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(92), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review, rdex) {
    return _c('div', {
      key: _vm.orderComponentKey,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [(review.product_reviewed_by_image && (review.product_reviewed_by_image != '')) ? _c('img', {
      attrs: {
        "src": review.product_reviewed_by_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right",
      staticStyle: {
        "padding-left": "6px"
      }
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(review.product_review) + "\r\n                          ")]), _c('div', {
      staticStyle: {
        "color": "#ffd900"
      }
    }, [_vm._l((parseInt(review.product_rate)), function(index) {
      return _c('span', {
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    }), _vm._l(((5 - parseInt(review.product_rate))), function(index) {
      return _c('span', {
        staticClass: "fa is-filled"
      }, [_vm._v("")])
    })], 2), _vm._v("\r\n                          " + _vm._s(review.product_reviewed_by)), _c('br'), _vm._v("\r\n                          " + _vm._s(review.product_review_date) + "\r\n                        "), _c('p')])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottombtn",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabView('manageBusinessCategoryProduct', _vm.sellpoint, _vm.product)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.buypoints) ? _c('div', [_vm._m(93)]) : _vm._e(), _vm._v(" "), (_vm.menu_view.settings) ? _c('div', [_vm._m(94)]) : _vm._e(), _vm._v(" "), (_vm.menu_view.storage) ? _c('div', [_vm._m(95)]) : _vm._e(), _vm._v(" "), (_vm.menu_view.knowledge) ? _c('div', [_vm._m(96)]) : _vm._e(), _vm._v(" "), (_vm.menu_view.invite) ? _c('div', [_vm._m(97)]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your orders from stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Sellpoints")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Businesses sellpoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Buypoints")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Buying Interests and settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Collections")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your total colections")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Sidehustle")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Agent/Sidehhustle Businesses")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("limits, accounts, orders, payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-cloud"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Storage")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your cloud storage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Knowledge Center")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Help, FAQs, terms, privacy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat"
  }, [_c('h5', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Business Profile")]), _vm._v(" "), _c('p', [_vm._v("Name, About, description, etc")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Orders")]), _vm._v(" "), _c('p', [_vm._v("Orders from customers and buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Transactions")]), _vm._v(" "), _c('p', [_vm._v("Recent and total transactions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Shipping / Delivery Information")]), _vm._v(" "), _c('p', [_vm._v("How you settle shipping and delivery ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Shipping / Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("Your Shipping Locations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Discounts, Vouchers, Coupons")]), _vm._v(" "), _c('p', [_vm._v("General Business discount settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Payments")]), _vm._v(" "), _c('p', [_vm._v("Money, Banks, Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Commissions")]), _vm._v(" "), _c('p', [_vm._v("General Business Commissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Rewards, Collection Boost")]), _vm._v(" "), _c('p', [_vm._v("General Rewards, Collections Boost...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Delete Business")]), _vm._v(" "), _c('p', [_vm._v("Request Business Information to be deleted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Business Details")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business")]), _vm._v(" - Transactions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Today")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment from")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Amount Paid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Type of Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Payment Ref")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left-50"
  }, [_c('p', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Business Shipping Information ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                  If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                  button.\r\n                              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Payment Information")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Processing Fees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To keep receiving Buyers Order transfers "), _c('b', [_vm._v("*directly*")]), _vm._v(" to your Bank Account, please ensure your Processing Fee\r\n                          is not zero or below")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Set your Payment Collection Gateway")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://ravepay.co",
      "target": "_blank"
    }
  }, [_vm._v("Checkout Ravepay")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Paystack  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Paystack Website to create and set up your account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("AfiaApp Pay Settlements")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Your Payments would be transferred to your Bank Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Paypal  - Direct Personal Integration")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You would be directed to Paypal Website to create and set up your account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('p', [_vm._v("Suggest Another ?")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Do you have another Platform you would like to use and collect your Payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - Commissions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Agent Commission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Set a general Agent Commission for your Business "), _c('br'), _vm._v("you can still set different commisions for any product and product items")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Processing Fees")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To keep receiving Buyers Order transfers "), _c('b', [_vm._v("*directly*")]), _vm._v(" to your Bank Account, please ensure your Processing Fee\r\n                          is not zero or below")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Settings")]), _vm._v(" - General Rewards, Collections Boost... ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Business Posts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [_vm._v("Comments: 30")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("OR")]), _vm._v(" Add any other category"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Product Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Price"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Product Details ")]), _vm._v(" "), _c('p', [_vm._v("Product Name, Description, Prices ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Product Types / Variations ")]), _vm._v(" "), _c('p', [_vm._v("Different types and variations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Specific Product Discounts and Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Delivery and Return Information")]), _vm._v(" "), _c('p', [_vm._v("Shipping and Delivery Return Information and Policies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat-pad"
  }, [_c('h6', [_vm._v("Shipping / delivery Information")]), _vm._v(" "), _c('p', [_vm._v("Specific Product Delivey Fees and Locations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Details")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Items and Variations")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Select a Group from below:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("Name this item if you want to")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Discounts And Coupons")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                            If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Delivery & Returns Information")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Delivery Location Fees")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Orders")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Settings")]), _vm._v(" - Product Reviews")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat card-01"
  }, [_c('h5', [_vm._v("My Buypoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat card-01"
  }, [_c('h5', [_vm._v("Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat card-01"
  }, [_c('h5', [_vm._v("Storage Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat card-01"
  }, [_c('h5', [_vm._v("How to Use My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat card-01"
  }, [_c('h5', [_vm._v("Invite a Friend")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c3f7e1"}!./src/pages/AppNaijaTradeMall/Account/template.html
// module id = 410
// module chunks = 0